import {
  ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend,
} from "recharts";
import { TrendingUp } from "lucide-react";

export default function AdminGrowthChart({ data = [] }) {
  return (
    <div className="bg-[#1A1A1A] border border-white/10 rounded-3xl p-5 sm:p-6 mt-6" data-testid="admin-growth-chart">
      <div className="flex items-center gap-2 mb-4">
        <TrendingUp className="w-4 h-4 text-[#E91E8C]" />
        <h3 className="text-sm font-bold font-heading">Crescita · ultime 6 settimane</h3>
        <span className="text-xs text-white/40 ml-auto">GMV & nuove registrazioni</span>
      </div>
      <ResponsiveContainer width="100%" height={240}>
        <ComposedChart data={data} margin={{ top: 5, right: 8, left: -14, bottom: 0 }}>
          <defs>
            <linearGradient id="gmvBar" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#E91E8C" stopOpacity={0.9} />
              <stop offset="100%" stopColor="#E91E8C" stopOpacity={0.3} />
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} />
          <XAxis dataKey="label" tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 11 }} tickLine={false} axisLine={false} />
          <YAxis yAxisId="left" tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 10 }} tickLine={false} axisLine={false} width={46} />
          <YAxis yAxisId="right" orientation="right" tick={{ fill: "rgba(255,255,255,0.4)", fontSize: 10 }} tickLine={false} axisLine={false} width={28} />
          <Tooltip
            contentStyle={{ background: "#0D0D0D", border: "1px solid rgba(255,255,255,0.1)", borderRadius: 12, fontSize: 12 }}
            labelStyle={{ color: "rgba(255,255,255,0.5)" }}
            formatter={(v, n) => (n === "GMV (€)" ? [`€${Number(v).toFixed(2)}`, n] : [v, n])}
          />
          <Legend wrapperStyle={{ fontSize: 11 }} />
          <Bar yAxisId="left" dataKey="gmv" name="GMV (€)" fill="url(#gmvBar)" radius={[6, 6, 0, 0]} maxBarSize={38} animationDuration={1100} />
          <Line yAxisId="right" type="monotone" dataKey="new_creators" name="Nuovi creator" stroke="#F5C6D6" strokeWidth={2.5} dot={{ r: 3 }} animationDuration={1300} />
          <Line yAxisId="right" type="monotone" dataKey="new_fans" name="Nuovi fan" stroke="#38BDF8" strokeWidth={2.5} dot={{ r: 3 }} animationDuration={1500} />
        </ComposedChart>
      </ResponsiveContainer>
    </div>
  );
}
